// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__WgZ0F","absolute":"Loading_absolute__N-FKx","roller":"Loading_roller__Cmx5j"};